import { AxiosError } from "axios";

export interface MultipleImportFileErrorResponse {
    status: string;
    errors?: ImportFileError[];
}

export interface ImportFileError {
    file: string;
    error: string;
}

export const hasMultipleImportFileErrors = (
    error: AxiosError
): error is AxiosError<MultipleImportFileErrorResponse> => {
    const { errors } = error.response?.data as MultipleImportFileErrorResponse;
    return Array.isArray(errors || []);
};
